<template>
  <div class="comment">
    <van-cell-group title="评论" :border="true" size="large">
      <div class="approvers">
          <van-row type="flex" class="approver">
            <van-col span="24" v-for="comment in comments" :key="comment.id">
            
              <span class='name' @click="answer(comment)">{{comment.user.name}}：</span>
              <span class='content'>{{comment.content}}</span>
              <!-- <span class='answer' @click="answer(comment)">回复</span> -->
              <span class='date'>{{comment.comment_time}}</span>
              
              <van-divider />
              
            </van-col>
            
            <van-col span="24">
              
              <van-field
                v-model="commentForm.content"
                center
                clearable
                left-icon="smile-comment-o"
                ref='content'
                id="content"
                @input='changContent'
                autosize
                border
                placeholder="添加评论，可@相关人员……" 
                >
                
                <template #button>
                  <van-button size="normal" @click="addComment" type="primary">提交</van-button>
                </template>
              </van-field>
             </van-col>

          </van-row>
          
        
        </div>
        <!--添加抄送人 -->

      
      
   
    </van-cell-group>
    
    <!-- <van-popup  position="bottom" v-model="user.show">
    <van-search placeholder="请输入用户姓名" v-model="userForm.user" @input="getUser()"/>
    <van-picker 
      cancel-button-text='取消' 
      value-key="name"    
      show-toolbar 
      :columns="user.data"  
      @confirm="atUser"
      @cancel="user.show = false"
    />
    </van-popup> -->
    <mu-dialog transition="slide-bottom" fullscreen lock-scroll scrollable :open.sync="user.show">
      <mu-paper :z-depth="1" class="demo-list-wrap">
        <div class="user_top">
          <mu-appbar color="indigo500">
            通讯录
            <mu-button icon slot="right">
              <!-- <mu-icon :value="close"></mu-icon> -->
              <van-icon name="close" @click="user.show = false" />
            </mu-button>
          </mu-appbar>
          
          <van-search placeholder="请输入用户姓名" v-model="userForm.user" @input="getUser()"/>
        </div>
        <div class="user_content">
          <mu-list v-for="(items,key) in user.data" :key="key">
            <mu-sub-header>{{key}}</mu-sub-header>
            <mu-list-item avatar button :ripple="false" v-for="item in items" :key="item.userid" @click="atUser(item)">
              <mu-list-item-action>
                <mu-avatar>
                  <img :src="item.thumb_avatar">
                </mu-avatar>
              </mu-list-item-action>
              <mu-list-item-title>{{item.name}}</mu-list-item-title>
              <mu-list-item-sub-title>{{item.position}}</mu-list-item-sub-title>
              <!-- <mu-list-item-action>
                <mu-icon :value="item.position"></mu-icon>
              </mu-list-item-action> -->
            </mu-list-item>
            <mu-divider></mu-divider>
          </mu-list>
        </div>
      </mu-paper>
    </mu-dialog>
    
  </div>
</template>

<script>
export default {
  name: 'Comment',
  props: {
    flow:Object,
    flow_id:String,
    users:Object,
  },
  data(){
    return{
      user:{
        show:false,
        data:this.users,
      },
      userForm:{
        user:'',
      },
      commentForm:{
        content:'',
        flow_id:this.flow_id,
        at_users:[],
        to_users:[],
      },
      comments:[]
    }
  },
  created(){
    setTimeout(() => {
      this.getComments()
      }, 3000)
  },
  methods:{
    getUser(){
      this.$http.post('get_users',this.userForm)
      .then((res)=>{
        console.log(res)
        this.user.data = res.data.data
        
      })

    },
    getComments(){
      console.log(this.flow.id)
      this.$http.post('get_comment',{flow_id:this.flow_id})
      .then((res)=>{
        console.log(res)
        if(res.data.code == 200){
          this.comments = res.data.data
        }
      })

    },
    addComment(){
      if(this.commentForm.content==''){
        this.$dialog.alert({
            message: '评论内容不得为空。',
        })
        return false;
      }
      // return false;
      this.commentForm.flow_id = this.flow.id
      this.$http.post('comment',this.commentForm)
      .then((res)=>{
        console.log(res)
        if(res.data.code ==200){
          this.$dialog.alert({
            message: res.data.msg,
          })
          .then((res)=>{
            this.commentForm.content = ''
            this.commentForm.at_users = []
            this.commentForm.to_users = []
            this.getComments()
          })
        }
      })
    },
    changContent(value){
      console.log(value)
      var str = value.toString()
      if(str.charAt(str.length - 1) == '@'){
        this.$refs.content.blur()
        this.user.show = true
      }


    },
    atUser(user){
      
      this.commentForm.content += (user.name+' ')
      this.commentForm.at_users.push(user.userid)
      this.user.show = false;
      this.userForm.user ='';
      // console.log(this.commentForm)
    },
    answer(comment){
      console.log(comment)
      this.commentForm.content += ('回复 '+comment.user.name+'：');
      this.commentForm.to_users.push(comment.userid)
      console.log(this.commentForm)

    },
    atjs(){
      // this.$refs.content.atwho({
      //   at: '@',
      //   displayTpl: "<li>${name}</li>",
      //   insertTpl: ":${name}:",
      //   data: this.user.data
      // });
      var at_config = {
        at: "@",
        data: this.user.data,
        headerTpl: '<div class="atwho-header">Member List<normal>↑&nbsp;↓&nbsp;</normal></div>',
        insertTpl: "${name}",
        displayTpl: "<li>${name}</li>",
        limit: 200
      }

      var inputor = $('#content').atwho(at_config);
      inputor.caret('pos', 47);
      inputor.focus().atwho('run');
      // $('#content').atwho({
      //   at: '@',
      //   displayTpl: "<li>${name}</li>",
      //   insertTpl: "${name}",
      //   // data: this.user.data,
      //   data:['Peter', 'Tom', 'Anne'],
      //   limit : 8 , 
      // });
    }
  },
  
  mounted() {

    
  },
  watch:{
    users:function(val){
      this.user.data = val
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.approvers{
  text-align: 0 auto;
  /* margin:10px; */
  /* margin-bottom:100px; */
}
.approver{
  /* float:left; */
  padding:10px;

}

.approver .van-step{
  display:block;

}
h3 {
  font-size:12px;
  margin:5px;
}
p{
  margin:0px;
  font-size:12px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  /* display: inline-block; */
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-cell-group__title{
  background-color:#3f51b5 ;
  font-size:14px;
  font-weight:blod;
  color:white;
  padding:13px;

}
.comment{
  
  margin-top:20px;

}
.name{
  text-align:left;
  float:left;
  line-height:18px;
  padding-left:20px;
  font-size:14px;
  color:#999999
}
.content{
  text-align:left;
  float:left;
  line-height:18px;
  padding-left:10px;
  font-size:14px;
  
}
.date{
  float:right;
  color:#999999;
  font-size:12px;

}
.answer{
  float:right;
  color:#999999;
  font-size:12px;
}
.van-divider{
  padding-top:8px;
}
.van-popup__close-icon {
    position: fixed;
    z-index: 99;
    color: #c8c9cc;
    font-size: 22px;
    cursor: pointer;
}

.user_top{
  position:fixed;
  top:0px;
  width:100%;
  z-index:2;
}
.user_content{
  margin-top:110px;
}
</style>
<style>
/* .mu-dialog-wrapper, .mu-dialog, .mu-dialog-body{
  max-height:none !important;
} */
.mu-dialog-fullscreen .mu-dialog-body {
    padding: 0;
    max-height: 1200px !important;
}
  
</style>

